import { render, staticRenderFns } from "./DragPhoto.vue?vue&type=template&id=eee04bfe&scoped=true&"
import script from "./DragPhoto.vue?vue&type=script&lang=js&"
export * from "./DragPhoto.vue?vue&type=script&lang=js&"
import style0 from "./DragPhoto.vue?vue&type=style&index=0&id=eee04bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee04bfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VFileInput})
